import { render, staticRenderFns } from "./Lgx02666920475176290222113.vue?vue&type=template&id=1ff06cd2&scoped=true&"
import script from "./Lgx02666920475176290222113.vue?vue&type=script&lang=js&"
export * from "./Lgx02666920475176290222113.vue?vue&type=script&lang=js&"
import style0 from "./Lgx02666920475176290222113.vue?vue&type=style&index=0&id=1ff06cd2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff06cd2",
  null
  
)

export default component.exports